import { COOKIE } from '@iva/utils';
const _terminator = (type, keys) => {
    keys.forEach((key) => {
        try {
            if (type === 'LS') {
                localStorage.removeItem(key);
            }
            else if (type === 'COOKIE') {
                COOKIE.removeCookie(key);
            }
        }
        catch (_a) {
            // noop
        }
    });
};
/**
 * Clean up stale data (some caching metadata used by already disabled identitites, etc.)
 */
export const browserCleanUp = () => {
    _terminator('LS', [
    // LS keys, if needed
    ]);
    _terminator('COOKIE', [
    // cookie names, if needed
    ]);
};
